module.exports = __webpack_public_path__ + "static/media/070.5f28fee9.jpg";